// filepath: /src/config/urls.js

// Configuration file for external URLs
const urls = {
  // Main application
  app: process.env.REACT_APP_THINKHEALTH_APP_URL,
  
  // System access and dashboard
  systemAccess: process.env.REACT_APP_SYSTEM_ACCESS_URL,
  dashboard: process.env.REACT_APP_DASHBOARD_URL,
  configuration: process.env.REACT_APP_CONFIGURATION_URL,
  
  // Invitation
  invitation: process.env.REACT_APP_INVITATION_URL,
  
  // License requests
  licenses: {
    student: process.env.REACT_APP_STUDENT_LICENSE_URL,
    doctor: process.env.REACT_APP_DOCTOR_LICENSE_URL,
    'doctor-pro-ai': process.env.REACT_APP_DOCTOR_PRO_AI_LICENSE_URL
  },
  
  // Contact information
  contact: {
    email: process.env.REACT_APP_CONTACT_EMAIL,
    phone: process.env.REACT_APP_CONTACT_PHONE,
    schedule: process.env.REACT_APP_CONTACT_SCHEDULE
  },
  
  // Contact and support
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
  
  // Additional URLs
  support: process.env.REACT_APP_SUPPORT_URL,
  docs: process.env.REACT_APP_DOCS_URL,
  api: process.env.REACT_APP_API_URL,
  
  // Social Media URLs
  social: {
    linkedin: process.env.REACT_APP_LINKEDIN_URL,
    instagram: process.env.REACT_APP_INSTAGRAM_URL,
    youtube: process.env.REACT_APP_YOUTUBE_URL
  },
  
  // API Endpoints
  apiEndpoints: {
    signup: process.env.REACT_APP_SIGNUP_API_URL,
    login: process.env.REACT_APP_LOGIN_API_URL,
    entities: process.env.REACT_APP_ENTITIES_API_URL,
    municipalities: process.env.REACT_APP_MUNICIPALITIES_API_URL,
    privacy: process.env.REACT_APP_PRIVACY_API_URL
  }
};

export default urls;
